import { Typography, List } from "@mui/material";
import "./index.css";

const YFSLabelTable = ({ label, items }) => {
  return (
    <div className="yfs-table-body">
      <div className="yfs-table-header">
        <Typography
          sx={{
            fontWeight: "bold",
            color: "#203669",
            textAlign: "center",
            fontSize: "14px",
          }}
        >
          {label}
        </Typography>
      </div>
      <div style={{ padding: "0 5px" }}>
        <List>{items}</List>
      </div>
    </div>
  );
};

export default YFSLabelTable;
